import { z } from 'zod'

const ACCEPTED_FILE_TYPES = [
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/webp',
]

export const overrideDeferralSchema = (t: (key: string) => string) =>
  z.object({
    deferralId: z
      .string()
      .min(1, t('dashboard.override_deferral.validation.deferral_required')),
    reasonText: z
      .string()
      .min(20, t('dashboard.override_deferral.validation.reason_min')),
    certificateFile: z
      .any()
      .refine(
        (value): value is File => value instanceof File,
        t('dashboard.override_deferral.validation.file_required'),
      )
      .refine(
        (file) => ACCEPTED_FILE_TYPES.includes(file.type),
        t('dashboard.override_deferral.validation.file_type'),
      ),
  })

export type OverrideDeferralFormValues = z.infer<
  ReturnType<typeof overrideDeferralSchema>
>
